export const EcosystemsList = [
  "Ethereum (ETH)",
  "Bitcoin (BTC)",
  "BNB Chain (BNB)",
  "Solana (SOL)",
  "Cardano (ADA)",
  "Polygon (MATIC)",
  "TRON (TRX)",
  "Avalanche (AVAX)",
  "Arbitrum (ARB)",
  "Optimism (OP)",
  "Fantom (FTM)",
  "Tezos (XTZ)",
  "NEAR Protocol (NEAR)",
  "Cosmos (ATOM)",
  "Hedera (HBAR)",
  "Algorand (ALGO)",
  "Celo (CELO)",
  "Harmony (ONE)",
  "Cronos (CRO)",
  "Kava (KAVA)",
  "VeChain (VET)",
  "Zilliqa (ZIL)",
  "Waves (WAVES)",
  "Elrond (EGLD)",
  "Flow (FLOW)",
  "IoTeX (IOTX)",
  "Aurora (AURORA)",
  "Moonbeam (GLMR)",
  "Gnosis (GNO)",
  "xDai Chain",
  "Kusama (KSM)",
  "Polkadot (DOT)",
  "Terra Classic (LUNC)",
  "Terra (LUNA)",
  "Stellar (XLM)",
  "ICON (ICX)",
  "NEO (NEO)",
  "Qtum (QTUM)",
  "EOS (EOS)",
  "Theta (THETA)",
  "Chiliz (CHZ)",
  "Bittorrent (BTT)",
  "OKX Chain (OKT)",
  "Oasis Network (ROSE)",
  "Internet Computer (ICP)",
  "Cortex (CTXC)",
  "Syscoin (SYS)",
  "Syntropy (NOIA)",
  "Telos (TLOS)",
  "Astar (ASTR)",
  "Kadena (KDA)",
  "Shiden Network (SDN)",
  "Secret (SCRT)",
  "Rootstock (RSK)",
  "Lisk (LSK)",
  "Nano (XNO)",
  "Horizen (ZEN)",
  "Decred (DCR)",
  "Zcash (ZEC)",
  "Bitcoin Cash (BCH)",
  "Litecoin (LTC)",
  "Dogecoin (DOGE)",
  "Dash (DASH)",
  "Stacks (STX)",
  "RSK Infrastructure Framework (RIF)",
  "Velas (VLX)",
  "Energi (NRG)",
  "Fusion (FSN)",
  "XinFin (XDC)",
  "Ethereum Classic (ETC)",
  "Ubiq (UBQ)",
  "EthereumPoW (ETHW)",
  "REI Network (REI)",
  "Theta Fuel (TFUEL)",
  "HECO Chain (HT)",
  "Tomochain (TOMO)",
  "BitShares (BTS)",
  "Ton Blockchain (TON)",
  "SEI Network"
];

export const FundingStageList = [
  "Pre-Seed",
  "Seed",
  "Private Sale",
  "Pre-ICO",
  "ICO",
  "IDO",
  "STO",
  "Public Sale",
  "Post ICO Sale",
  "Series A, B, C",
  "Grants",
];

export const RequestTypeList = [
  "Technical Collaboration",
  "Funding",
  "Listing",
  "Marketing",
  "Integrations",
  "Community Building",
  "Explore",
];

export const ProfileStatusList = ["Email Verified", "TG Verified"];

export const LocationList = ["Global",'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bangladesh', 'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', '$_[', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe', "Remote"];

export const PartnershipInterestList = [
  "AI & Big Data",
  "	 Art	",
  "	 Asset Management	",
  "	 Asset-backed Tokens	",
  "	 Augmented Reality	",
  "	 Automated Market Maker (AMM)	",
  "	 BNB Chain Ecosystem	",
  "	 Centralized Exchange (CEX)	",
  "	 Charity	",
  "	 Communication	",
  "	Content Creation	",
  "	 Crowdfunding	",
  " DAO	",
  "	 Dapp	",
  "	 Decentralized Exchange (DEX)	",
  "	 DeFi	",
  "	 Derivatives	",
  "	 Dex Aggregator	",
  "	 E-Commerce	",
  "	 Education	",
  "	 Energy	",
  "	 Entertainment	",
  "	 Esports	",
  "	 Ethereum Ecosystem	",
  "	 Exchange-based Tokens	",
  "	 Fan Token	",
  "	 Farming-as-a-Service (FaaS)	",
  "	 File Sharing	",
  "	 Gaming	",
  "	 Governance	",
  "	 Gambling	",
  "	 Healthcare	",
  "	 Insurance	",
  "	 Interoperability	",
  "	 IoT	",
  "	 Launchpad	",
  "	 Layer 1 (L1)	",
  "	 Layer 2 (L2)	",
  "	 Legal	",
  "	 Lending & Borrowing	",
  "	 Loyalty	",
  "	 Manufacturing	",
  "	 Marketplaces	",
  "	 Marketing	",
  "	 Media	",
  "	 Memes	",
  "	 Metaverse	",
  "	 Mining	",
  "	 Mobile	",
  "	 Music	",
  "	 NFT	",
  "	 Oracles	",
  "	 Polkadot Ecosystem	",
  "	 Privacy	",
  "	 Real Estate	",
  "	 Rebase Tokens	",
  "	 Retail	",
  "	 RWA (Real World Assets)	",
  "	 Sharing Economy	",
  "	 Smart Contract Platform	",
  "	 Social Money	",
  "	 Social	",
  "	 Sports	",
  "	 Stablecoins	",
  "	 Storage	",
  "	 Supply Chain & Logistics	",
  "	 Synthetic Issuer	",
  "	 Technology & Science	",
  "	 Tokenized Bitcoin	",
  "	 Trading	",
  "	 Virtual Goods	",
  "	 VR/AR	",
  "	 Wallet	",
  "	 Web3	",
  "Yield Aggregator",
];
export const CategoryList = [
  "AI & Big Data",
  "Art",
  "Asset Management",
  "Asset-backed Tokens	",
  "Augmented Reality",
  "Automated Market Maker(AMM)",
  "BNB Chain Ecosystem	",
  "Centralized Exchange (CEX)	",
  "Charity",
  "Communication",
  "Content Creation	",
  "Crowdfunding",
  " DAO	",
  "	 Dapp	",
  "	 Decentralized Exchange (DEX)	",
  "	 DeFi	",
  " Depin ",
  "	 Derivatives	",
  "	 Dex Aggregator	",
  "	 E-Commerce	",
  "	 Education	",
  "	 Energy	",
  "	 Entertainment	",
  "	 Esports	",
  "	 Ethereum Ecosystem	",
  "	 Exchange-based Tokens	",
  "	 Fan Token	",
  "	 Farming-as-a-Service (FaaS)	",
  "	 File Sharing	",
  "	 Gaming	",
  "	 Governance	",
  "	 Gambling	",
  "	 Healthcare	",
  "	 Insurance	",
  "	 Interoperability	",
  "	 IoT	",
  "	 Launchpad	",
  "	 Layer 1 (L1)	",
  "	 Layer 2 (L2)	",
  "	 Legal	",
  "	 Lending & Borrowing	",
  "	 Loyalty	",
  "	 Manufacturing	",
  "	 Marketplaces	",
  "	 Marketing	",
  "	 Media	",
  "	 Memes	",
  "	 Metaverse	",
  "	 Mining	",
  "	 Mobile	",
  "	 Music	",
  "	 NFT	",
  "	 Oracles	",
  "	 Polkadot Ecosystem	",
  "	 Privacy	",
  "	 Real Estate	",
  "	 Rebase Tokens	",
  "	 Retail	",
  "	 RWA (Real World Assets)	",
  "  SEI Network",
  "	 Sharing Economy	",
  "	 Smart Contract Platform	",
  "	 Social Money	",
  "	 Social	",
  "	 Sports	",
  "	 Stablecoins	",
  "	 Storage	",
  "	 Supply Chain & Logistics	",
  "	 Synthetic Issuer	",
  "	 Technology & Science	",
  "	 Tokenized Bitcoin	",
  "  Ton Blockchain ",
  "	 Trading	",
  "	 Virtual Goods	",
  "	 VR/AR	",
  "	 Wallet	",
  "	 Web3	",
  "Yield Aggregator",
];
